export default __webpack_public_path__ + "static/media/vibe_button.56a09a04.png";